import { List } from 'antd';
import { ErrorDisplay } from 'components/ErrorDisplay';
import { ButtonRating } from 'components/Rating/components/rating-button/rating-button';
import { SliderRating } from 'components/Rating/components/rating-slider/rating-slider';
import { Title } from 'components/mvp-typography';
import {
  QuestionConfig,
  QuestionnaireSubsectionConfig
} from 'data/questionnaire-config-type';
import { isNumber } from 'lodash';

export interface QuestionConfigWithResponse extends QuestionConfig {
  value: number | string | boolean | string[];
}

export interface QuestionnairePageProps
  extends Omit<
    QuestionnaireSubsectionConfig,
    'description' | 'instructions' | 'questions' | 'id'
  > {
  items: QuestionConfigWithResponse[];
  onChange: (item: Pick<QuestionConfigWithResponse, 'title' | 'value'>) => void;
}

export function QuestionnairePage(props: QuestionnairePageProps) {
  return (
    <div
      style={{
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <List
        className="listcircle-rbl"
        itemLayout="vertical"
        dataSource={props.items}
        split={true}
        renderItem={(item, i) => {
          return (
            <List.Item
              key={i}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                textAlign: 'center',
                marginBottom: '30px',
                borderBottom: 'none'
              }}
            >
              <Title level={2} style={{ fontWeight: 'bold' }}>
                {item.title}
              </Title>

              <QuestionnaireInput
                type={props.type ?? 'button'}
                item={item}
                onChange={props.onChange}
                min={props.min}
                max={props.max}
                beforeLabel={props.beforeLabel}
                afterLabel={props.afterLabel}
                colorsForward={props.colorsForward}
                iconsForward={props.iconsForward}
              />
            </List.Item>
          );
        }}
      />
    </div>
  );
}

/**
 * Displays an input element for a Questionnaire. The `type` parameter is used to choose which component should be rendered
 */
export function QuestionnaireInput(
  props: {
    item: QuestionConfigWithResponse;
    disabled?: boolean;
  } & Pick<
    QuestionnaireSubsectionConfig,
    | 'type'
    | 'min'
    | 'max'
    | 'beforeLabel'
    | 'afterLabel'
    | 'colorsForward'
    | 'iconsForward'
  > &
    Pick<QuestionnairePageProps, 'onChange'>
) {
  const value = props.item.value;

  if (!isNumber(value)) {
    return (
      <ErrorDisplay
        description=""
        error={new Error(`Value '${value}' is not a number`)}
        title="Input value is not a number"
      />
    );
  }

  return props.type === 'slider' ? (
    <SliderRating
      value={value}
      onChange={value => props.onChange({ ...props.item, value })}
      min={props.min}
      max={props.max}
      beforeLabel={props.beforeLabel}
      afterLabel={props.afterLabel}
      disabled={props.disabled}
      iconsForward={props.iconsForward}
    />
  ) : (
    <ButtonRating
      value={value}
      onChange={value => props.onChange({ ...props.item, value })}
      min={props.min}
      max={props.max}
      beforeLabel={props.beforeLabel}
      afterLabel={props.afterLabel}
      colorsForward={props.colorsForward}
      iconsForward={props.iconsForward}
      disabled={props.disabled}
    />
  );
}
